package uk.co.nickthecoder.kojak

internal class ImmutableList<T>(private val protectedList: List<T>) : List<T> by protectedList {
    override fun equals(other: Any?): Boolean {
        if (other is List<*>) {
            return other == protectedList
        }
        return false
    }
}
